<div class="weight-type" *ngIf="maxSpecCoilWeightOptionAvailable">
	<mat-form-field [hideRequiredMarker]="true" class="card-container-column weight-type-width" floatLabel="always">
		<mat-label translate>need4steel.wizard.product.weight.type.label</mat-label>
		<mat-select [formControl]="form.getFormWeightType()" (change)="onWeightTypeChange()">
			<mat-option *ngFor="let weighttype of weightTypes" [value]="weighttype.code">
				<span>{{ weighttype.value }}</span>
			</mat-option>
		</mat-select>
	</mat-form-field>
</div>
<div class="top-controls-row">
	<div class="add-btn">
		<button mat-button [disabled]="!disabled || !isSoldtoSelected" type="button" (click)="viewOrderedHistory()" tabindex="-1" copoFocusMe>
			<span class="add-product" translate>need4steel-schedule.button</span>
			<mat-icon iconPositionEnd class="plus-icon plus-icon-size" matSuffix svgIcon="schedule"  [ngClass]="{'icon-disabled':!disabled,
				'icon-enabled': disabled}"></mat-icon>
		</button>
	</div>

	<div class="exchange-rate-group" *ngIf="hasExchangeRateToDisplay()">
		<div class="exchange-rate-field">
			<div class="card-content-label" translate>need4steel.wizard.exchange-rate.rate</div>
			<div class="card-content-value">
				1 EUR = {{ getExchangeRateValue() }} {{ getExchangeRateCurrency() }}
			</div>
		</div>
		<div class="exchange-rate-field">
			<div class="card-content-label" translate>need4steel.wizard.exchange-rate.reference-date</div>
			<div class="card-content-value">{{ getExchangeRateReferenceDate() }}</div>
		</div>
	</div>
</div>
<form [formGroup]="productFormGroup" novalidate autocomplete="off">
	<div class="grid-column-one-full card-block">
		<div *ngIf="largeScreen" formArrayName="productSpecifications">
			<div @deleteItemTrigger class="card-product-block" *ngFor="let itemrow of productResultControl; let i=index" [formGroupName]="i" #rows>
				<div *ngIf="getConfigErrorMsg(i) !== '' && getConfigErrorMsg(i).length > 0">
					<div class="card-block copo-notification-block">
						<mat-icon svgIcon="alert" [attr.title]="'quapp.alert' | translate" class="copo-notification-icon copo-hint-warning"></mat-icon>
						<div class="copo-offer-flex-container-col">
							<div class="card-header-label"> <b translate> need4steel.wizard.stepper.product.itemnumber</b> &nbsp;<b>{{ i+1 | number: '3.' }} </b></div>
								{{getConfigErrorMsg(i)}}
						</div>
					</div>
				</div>
				<div class="card-header copo-dark-theme">
					<div class="item-header-label step-product-spec-field ">
						<mat-label class="item-header-label item-number-width" translate>need4steel.wizard.stepper.product.itemnumber</mat-label>
						<div class="item-number-width"><span> {{ i+1 | number: '3.' }}</span></div>
						</div>
						<mat-form-field [hideRequiredMarker]="true" class="card-container-column" floatLabel="always" subscriptSizing="dynamic">
							<mat-label class="card-header-label" translate>need4steel.wizard.stepper.product.steelgrade</mat-label>
							<mat-select class="steel-grade-text-color copo-select" (selectionChange)="onSteelgradeChange($event, i);prepareDataAndCallForSimulateA2Cproduct(i);" formControlName="steelGrade"
								[value]="getSteelGradeValue(i)" [matTooltip]="getSteelGradeValue(i)">
								<mat-option *ngFor="let steelgrade of steelGrades" [value]="steelgrade" [matTooltip]="steelgrade">
									<span>{{steelgrade}}</span></mat-option>
							</mat-select>
						</mat-form-field>
						<mat-form-field [hideRequiredMarker]="true" class="card-container-column step-product-spec-field" floatLabel="always" subscriptSizing="dynamic">
							<mat-label class="card-header-label" translate>need4steel.wizard.stepper.product.thickness
							</mat-label>
							<mat-select *ngIf="isThicknessListOfValues" (selectionChange)="onThicknessChange(i, $event.value)" type="number" formControlName="thickness" [value]="getThicknessValue(i)">
								<mat-option *ngFor="let thickness of getThicknessList(i)" [value]="thickness"><span>{{thickness}}</span></mat-option>
							</mat-select>
							<input *ngIf="!isThicknessListOfValues" matInput [readonly]="isThicknessDisabled(i)" (change)="onThicknessChangeForTextField(i, $event)" type="number" class="list-view" formControlName="thickness" copoInputNumber [decimalCount]="2" [formControl]="getControl(i, 'thickness')" [max]="9999999999">
							<mat-icon *ngIf="!isThicknessListOfValues" matSuffix class="pencil-icon pencil-icon-red" svgIcon="copo_pencil"></mat-icon>
							<mat-hint>
								<ng-container *ngIf="isThicknessListOfValues else ThicknesAsRange">
									<span class="hint-font-color" *ngIf="!getSteelGradeValue(i)" translate>need4steel.dialog.thickness.content</span>
								</ng-container>
								<ng-template #ThicknesAsRange>
									<span *ngIf="!getThicknessHintText(i) else thicknessHintText;" class="hint-font-color" translate>need4steel.dialog.thickness.content</span>
									<ng-template #thicknessHintText>
										<span class="hint-font-color">{{ getThicknessHintText(i) }}</span>
									</ng-template>
								</ng-template>
							</mat-hint>
							<mat-error *ngIf="(isThicknessListOfValues === false) && checkMinMaxThickness(i)" [matTooltip]="('need4steel.wizard.thickness.range.error' | translate) +' '+ getThicknessHintText(i)">
								<span translate>need4steel.wizard.thickness.range.error</span>&nbsp;<span>{{ getThicknessHintText(i) }}</span>
							</mat-error>
						</mat-form-field>
						<mat-form-field [hideRequiredMarker]="true" class="card-container-column step-product-spec-field" floatLabel="always" subscriptSizing="dynamic">
							<mat-label class="card-header-label" translate>need4steel.wizard.stepper.product.width
							</mat-label>
							<mat-select *ngIf="useWidthDropdown(i)" type="number" formControlName="width" [value]="getWidthValue(i)" (selectionChange)="onWidthChange(i, $event.value)">
								<mat-option *ngFor="let width of getWidthList(i)" [value]="width"><span>{{width}}</span></mat-option>
							</mat-select>
							<input *ngIf="!useWidthDropdown(i)" matInput class="field-width list-view" type="number" formControlName="width"
							(change)="onWidthChangeForTextField(i, $event)" [readonly]="isWidthDisabled(i)" copoInputNumber [decimalCount]="0" [formControl]="getControl(i, 'width')" [max]="9999999999">
							<mat-icon *ngIf="!useWidthDropdown(i)" matSuffix class="pencil-icon pencil-icon-red" svgIcon="copo_pencil"></mat-icon>
							<mat-hint>
								<ng-container *ngIf="useWidthDropdown(i) else hintForWidthRange">
									<span class="hint-font-color" *ngIf="!getThicknessValue(i) && isThicknessListOfValues else thicknessIsRange" translate>need4steel.dialog.width.list.content</span>
									<ng-template #thicknessIsRange>
										<span class="hint-font-color" *ngIf="!getThicknessValue(i)" translate>need4steel.dialog.width.content</span>
									</ng-template>
								</ng-container>
								<ng-template #hintForWidthRange>
									<span class="hint-font-color" *ngIf="getWidthHintText(i) else noHintTextForWidth">{{ getWidthHintText(i) }}</span>
									<ng-template #noHintTextForWidth>
										<span class="hint-font-color" *ngIf="!getThicknessValue(i)" translate>need4steel.dialog.width.content</span>
									</ng-template>
								</ng-template>
							</mat-hint>
							<mat-error *ngIf="(!useWidthDropdown(i)) && checkMinMaxWidth(i)" [matTooltip]="('need4steel.wizard.width.range.error' | translate) +' '+ getWidthHintText(i)">
								<span translate>need4steel.wizard.width.range.error</span>&nbsp;<span>{{ getWidthHintText(i) }}</span>
							</mat-error>
						</mat-form-field>
						<ng-container *ngIf="getWeightType() === 'maxNetWeightValue'">
							<mat-form-field [hideRequiredMarker]="true" class="card-container-column step-product-spec-field" floatLabel="always" subscriptSizing="dynamic">
								<mat-label class="card-header-label field-width" translate>need4steel.wizard.stepper.product.coilweight
								</mat-label>
								<input matInput class="field-width" (change)="onMaxCoilWeightChange(i, $event)"
									type="number" formControlName="maxCoilWeight"
									[readonly]="isMaxCoilWeightDisabled(i)" copoInputNumber [decimalCount]="2" [formControl]="getControl(i, 'maxCoilWeight')" [max]="9999999999">
								<mat-icon matSuffix class="pencil-icon pencil-icon-red" svgIcon="copo_pencil"></mat-icon>
								<mat-hint>
									<span class="hint-font-color">{{ getMaxCoilWeightHintText() }}</span>
								</mat-hint>
								<mat-error *ngIf="checkMinMaxCoilWeight(i)" [matTooltip]="('need4steel.wizard.maxcoilweight.range.error' | translate) +' '+ getMaxCoilWeightHintText()">
									<span translate>need4steel.wizard.maxcoilweight.range.error</span>&nbsp;<span>{{ getMaxCoilWeightHintText() }}</span>
								</mat-error>
							</mat-form-field>
						</ng-container>
						<ng-container *ngIf="getWeightType() === 'maxWeightPerWidthUnitValue'">
							<mat-form-field [hideRequiredMarker]="true" class="card-container-column step-product-spec-field" floatLabel="always" subscriptSizing="dynamic">
								<mat-label class="card-header-label field-width" translate>need4steel.wizard.product.specific.weight
								</mat-label>
								<input matInput class="field-width" (change)="onMaxSpecificWeightChange(i, $event)"
									type="number" formControlName="maxSpecificWeight"
									[readonly]="isMaxSpecWeightDisabled(i)" copoInputNumber [decimalCount]="2" [formControl]="getControl(i, 'maxSpecificWeight')" [max]="9999999999">
								<mat-icon matSuffix class="pencil-icon pencil-icon-red" svgIcon="copo_pencil"></mat-icon>
								<mat-hint>
									<span class="hint-font-color">{{ getMaxSpecificWeightHintText(i) }}</span>
								</mat-hint>
								<mat-error *ngIf="checkMinMaxSpecificWeight(i)"
									[matTooltip]="('need4steel.wizard.maxspecificweight.range.error' | translate) +' '+ getMaxSpecificWeightHintText(i)">
									<span translate>need4steel.wizard.maxspecificweight.range.error</span>&nbsp;<span>{{ getMaxSpecificWeightHintText(i) }}</span>
								</mat-error>
							</mat-form-field>
						</ng-container>
						<mat-form-field [hideRequiredMarker]="true" class="card-container-column step-product-spec-field" floatLabel="always" subscriptSizing="dynamic">
							<mat-label class="placeholder" translate>need4steel.wizard.stepper.product.coil</mat-label>
							<input matInput class="coil-input" (change)="onCoilNumberChange(i, $event)"
								type="number" formControlName="coil"
								[readonly]="isCoilDisabled(i)" copoInputNumber [decimalCount]="0" [formControl]="getControl(i, 'coil')" [max]="9999999999">
							<mat-icon matSuffix class="pencil-icon pencil-icon-red" svgIcon="copo_pencil"></mat-icon>
							<mat-error *ngIf="checkCoilError(i)" [matTooltip]="'need4steel.wizard.coil.error' | translate">
								<span translate>need4steel.wizard.coil.error</span>
							</mat-error>
						</mat-form-field>
						<button type="button" mat-icon-button *ngIf="getPrice(i) !== priceDefaultValue && getPrice(i) !== ''else noPriceValue" class="card-container-column card-column-eye" (click)="viewProductDetails(i)" [matTooltip]="getToolTipDescription(i)"><mat-icon class="copo-eye-closed copo-eye-icon-open" svgIcon="open_eye"></mat-icon></button>
						<ng-template #noPriceValue>
							<div class="card-container-column card-column-eye" [matTooltip]="getToolTipDescription(i)" ><mat-icon class="copo-eye-closed eye-closed-icon-white" svgIcon="closed_eye"></mat-icon></div>
						</ng-template>
						<div class="card-container-column">
							<div class="card-header-label total-weight-col" translate>need4steel.wizard.stepper.product.total.weight
								<span class="overflow-wrap" *ngIf="getTotalWeight(i) !== priceDefaultValue">&nbsp;&nbsp;{{getTotalWeightDecimal(i) | copoNumber:'amount':''}}&nbsp;t</span>
								<span class="overflow-wrap" *ngIf="getTotalWeight(i) === priceDefaultValue">&nbsp;&nbsp;{{getTotalWeight(i)}}&nbsp;t</span>
							</div>
						</div>
					<div class="card-header-right">
						<button type="button" mat-icon-button [matMenuTriggerFor]="menu">
							<mat-icon svgIcon="md:more_vert"></mat-icon>
						</button>
						<mat-menu #menu="matMenu" xPosition="before" yPosition="below">
							<button type="button" mat-menu-item (click)="resetProduct(i, false)"><span translate>need4steel.wizard.stepper.product.action.reset</span></button>
							<button type="button" mat-menu-item [disabled]="productsCount < 2" (click)="productsCount > 1 && removeProductResult(i)"><span translate>need4steel.wizard.stepper.product.action.delete</span></button>
							<button type="button" mat-menu-item [disabled]="productsCount >= 100" (click)="duplicateProduct(i)"><span translate>need4steel.wizard.stepper.product.action.duplicate</span></button>
						</mat-menu>
					</div>
				</div>
				<!-- 2nd row -->
				<div class="card-content">
					<div [ngClass]="(maxSpecCoilWeightOptionAvailable ? 'card-content-left-1': 'card-content-left')">
						<ng-container *ngIf="secondRowVariables" formGroupName="variableFormGroup">
						@for (variable of secondRowVariables; track variable.field) {
							@if (!isVariableSpecific(variable.field)) {
								<mat-form-field class="copo-content-product card-header-double-span copo-form-field">
								<mat-label class="card-content-label">
									<ng-container *ngIf="variable.fieldDescription === toleranceField; else otherVariables">
									<span translate>need4steel.wizard.thickness.tolerance.field</span>
									</ng-container>
									<ng-template #otherVariables>
									{{getFieldLabel(variable.field)}}
									</ng-template>
								</mat-label>
								<mat-select [formControlName]="variable.field"
											[value]="getVariableListValue(i, variable.field)"
											[matTooltip]="getVariableListValue(i, variable.field)"
											(selectionChange)="prepareDataAndCallForSimulateA2Cproduct(i)">
									<ng-container *ngFor="let option of getVariableOptions(i, variable); let j=index">
									<mat-option *ngIf="variable.field === 'additionalTest' && j === 0" value="">
										<span translate>fastlane.itemlist.product.coil_axis.default</span>
									</mat-option>
									<mat-option [value]="option.description" [matTooltip]="option.description">
										<span>{{option.description}}&nbsp;</span>
									</mat-option>
									</ng-container>
								</mat-select>
								<mat-error *ngIf="variable.field === 'packagingCode' && isNotValidConstraints(i, variable.field)">
									<span translate>need4steel-logistic-routes.packaging.errormsg</span>
								</mat-error>
								</mat-form-field>
							}
						}
						</ng-container>
					</div>
					<div class="card-content-right price-info-block">
						<div class="copo-price-block">
							<span *ngIf="getLoader(i) === 'true'">
								<copo-loading-spinner class="loading-icon"></copo-loading-spinner>
							</span>
							<span *ngIf="getConfigErrorMsg(i) !== '' || getConfigErrorMsg(i).length > 0" class="copo-hint-warning"><mat-icon svgIcon="alert" class="copo-hint-warning-icon" matTooltip="Error occurred"></mat-icon></span>
							<span class="copo-underscore">{{getTotalPrice(i) }}</span>
							<b><span translate>need4steel-product-details.effectivedelivered</span></b>
						</div>
						<div *ngIf="getLoader(i) !== 'true' && getConfigErrorMsg(i) === '' && this.getPriceNumber(i) > 0 && hasExchangeRateToDisplay()" class="estimated-price-line">
							<i><span translate>need4steel.wizard.estimated</span> {{ getEstimatedPrice(i) }}/t <span translate>need4steel-summary-details.effectivedelivered</span></i>
						</div>
					</div>
				</div>
				<mat-divider class="mat-divider"></mat-divider>
			</div>
		</div>
		<div *ngIf="!largeScreen" formArrayName="productSpecifications">
			<div @deleteItemTrigger class="card-product-block" *ngFor="let itemrow of productResultControl; let i=index" [formGroupName]="i" #rows>
				<div *ngIf="getConfigErrorMsg(i) !== '' && getConfigErrorMsg(i).length > 0">
					<div class="card-block copo-notification-block">
						<mat-icon svgIcon="alert" [attr.title]="'quapp.alert' | translate" class="copo-notification-icon copo-hint-warning"></mat-icon>
						<div class="copo-offer-flex-container-col">
							<div class="card-header-label"> <b translate> need4steel.wizard.stepper.product.itemnumber</b> &nbsp;<b>{{ i+1 | number: '3.' }}</b></div>
								{{getConfigErrorMsg(i)}}
						</div>
					</div>
				</div>
				<div class="card-header copo-dark-theme">
					<div>
						<div class="card-header-label item-number-width" translate>need4steel.wizard.stepper.product.itemnumber</div>
						<div class="item-number-width"> <span> {{ i+1 | number: '3.' }}</span></div>
					</div>
					<mat-form-field [hideRequiredMarker]="true" class="card-container-column" floatLabel="always" subscriptSizing="dynamic">
						<mat-label class="card-header-label" translate>need4steel.wizard.stepper.product.steelgrade</mat-label>
						<mat-select class="steel-grade-text-color copo-select" [value]="getSteelGradeValue(i)" [matTooltip]="getSteelGradeValue(i)"
							(selectionChange)="onSteelgradeChange($event, i);prepareDataAndCallForSimulateA2Cproduct(i);" formControlName="steelGrade">
							<mat-option *ngFor="let steelgrade of steelGrades" [value]="steelgrade" [matTooltip]="steelgrade">
								<span>{{steelgrade}}</span></mat-option>
						</mat-select>
					</mat-form-field>
					<button type="button" mat-icon-button *ngIf="getPrice(i) !== priceDefaultValue && getPrice(i) !== ''else noPriceValue" class="card-container-column card-column-eye" (click)="viewProductDetails(i)" [matTooltip]="getToolTipDescription(i)"><mat-icon class="copo-eye-closed copo-eye-icon-open" svgIcon="open_eye"></mat-icon></button>
					<ng-template #noPriceValue>
						<div class="card-container-column card-column-eye" [matTooltip]="getToolTipDescription(i)" ><mat-icon class="copo-eye-closed eye-closed-icon-white" svgIcon="closed_eye"></mat-icon></div>
					</ng-template>
					<div class="card-container-column">
						<div class="card-header-label total-weight-col" translate>need4steel.wizard.stepper.product.total.weight
							<span class="overflow-wrap" *ngIf="getTotalWeight(i) !== priceDefaultValue">&nbsp;&nbsp;{{getTotalWeightDecimal(i) | copoNumber:'amount':''}}&nbsp;t</span>
							<span class="overflow-wrap" *ngIf="getTotalWeight(i) === priceDefaultValue">&nbsp;&nbsp;{{getTotalWeight(i)}}&nbsp;t</span>
						</div>
					</div>
					<div class="card-header-right">
						<button type="button" mat-icon-button [matMenuTriggerFor]="menu">
							<mat-icon svgIcon="md:more_vert"></mat-icon>
						</button>
						<mat-menu #menu="matMenu" xPosition="before" yPosition="below">
							<button type="button" mat-menu-item (click)="resetProduct(i, false)"><span translate>need4steel.wizard.stepper.product.action.reset</span></button>
							<button type="button" mat-menu-item [disabled]="productsCount < 2" (click)="productsCount > 1 && removeProductResult(i)"><span translate>need4steel.wizard.stepper.product.action.delete</span></button>
							<button type="button" mat-menu-item [disabled]="productsCount >= 100" (click)="duplicateProduct(i)"><span translate>need4steel.wizard.stepper.product.action.duplicate</span></button>
						</mat-menu>
					</div>
				</div>
				<div class="card-content">
					<div class="content-grid-mobile">
						<mat-form-field [hideRequiredMarker]="true" class="card-container-column step-product-spec-field" floatLabel="always" subscriptSizing="dynamic">
							<mat-label class="card-content-label-1 field-width" translate>need4steel.wizard.stepper.product.thickness</mat-label>
							<mat-select *ngIf="isThicknessListOfValues else thicknessRange;" (selectionChange)="onThicknessChange(i, $event.value)" type="number" formControlName="thickness" [value]="getThicknessValue(i)">
								<mat-option *ngFor="let thickness of getThicknessList(i)" [value]="thickness"><span>{{thickness}}</span></mat-option>
							</mat-select>
							<ng-template #thicknessRange>
								<input matInput [readonly]="isThicknessDisabled(i)" (change)="onThicknessChangeForTextField(i, $event)" type="number" class="list-view" formControlName="thickness" copoInputNumber [decimalCount]="2" [formControl]="getControl(i, 'thickness')" [max]="9999999999">
								<mat-icon matSuffix class="pencil-icon pencil-icon-red" svgIcon="copo_pencil"></mat-icon>
							</ng-template>
							<mat-hint>
								<ng-container *ngIf="isThicknessListOfValues else ThicknesAsRange">
									<span *ngIf="!getSteelGradeValue(i)" translate>need4steel.dialog.thickness.content</span>
								</ng-container>
								<ng-template #ThicknesAsRange>
									<span *ngIf="!getThicknessHintText(i) else thicknessHintText;" class="hint-font-color" translate>need4steel.dialog.thickness.content</span>
									<ng-template #thicknessHintText>
										<span>{{ getThicknessHintText(i) }}</span>
									</ng-template>
								</ng-template>
							</mat-hint>
							<mat-error *ngIf="(isThicknessListOfValues === false) && checkMinMaxThickness(i)" [matTooltip]="('need4steel.wizard.thickness.range.error' | translate) +' '+ getThicknessHintText(i)">
								<span translate>need4steel.wizard.thickness.range.error</span>&nbsp;<span>{{ getThicknessHintText(i) }}</span>
							</mat-error>
						</mat-form-field>
						<mat-form-field [hideRequiredMarker]="true" class="card-container-column step-product-spec-field" floatLabel="always" subscriptSizing="dynamic">
							<mat-label class="card-content-label-1 field-width" translate>need4steel.wizard.stepper.product.width
							</mat-label>
							<mat-select *ngIf="useWidthDropdown(i) else widthAsRange;" type="number" formControlName="width" [value]="getWidthValue(i)" (selectionChange)="onWidthChange(i, $event.value)">
								<mat-option *ngFor="let width of getWidthList(i)" [value]="width"><span>{{width}}</span></mat-option>
							</mat-select>
							<ng-template #widthAsRange>
								<input matInput class="field-width list-view" type="number" formControlName="width"
								(change)="onWidthChangeForTextField(i, $event)" [readonly]="isWidthDisabled(i)" copoInputNumber [decimalCount]="0" [formControl]="getControl(i, 'width')" [max]="9999999999">
								<mat-icon matSuffix class="pencil-icon pencil-icon-red" svgIcon="copo_pencil"></mat-icon>
							</ng-template>
							<mat-hint>
								<ng-container *ngIf="useWidthDropdown(i) else hintForWidthRange">
									<span *ngIf="!getThicknessValue(i) && isThicknessListOfValues else thicknessIsRange" translate>need4steel.dialog.width.list.content</span>
									<ng-template #thicknessIsRange>
										<span *ngIf="!getThicknessValue(i)" translate>need4steel.dialog.width.content</span>
									</ng-template>
								</ng-container>
								<ng-template #hintForWidthRange>
									<span *ngIf="getWidthHintText(i) else noHintTextForWidth">{{ getWidthHintText(i) }}</span>
									<ng-template #noHintTextForWidth>
										<span *ngIf="!getThicknessValue(i)" translate>need4steel.dialog.width.content</span>
									</ng-template>
								</ng-template>
							</mat-hint>
							<mat-error *ngIf="(!useWidthDropdown(i)) && checkMinMaxWidth(i)" [matTooltip]="('need4steel.wizard.width.range.error' | translate) +' '+ getWidthHintText(i)">
								<span translate>need4steel.wizard.width.range.error</span>&nbsp;<span>{{ getWidthHintText(i) }}</span>
							</mat-error>
						</mat-form-field>
						<ng-container *ngIf="getWeightType() === 'maxNetWeightValue'">
							<mat-form-field [hideRequiredMarker]="true" class="card-container-column step-product-spec-field" floatLabel="always" subscriptSizing="dynamic">
								<mat-label class="card-content-label-1 field-width" translate>need4steel.wizard.stepper.product.coilweight
								</mat-label>
								<input matInput class="field-width" type="number" formControlName="maxCoilWeight"
									(change)="onMaxCoilWeightChange(i, $event)" [readonly]="isMaxCoilWeightDisabled(i)" copoInputNumber [decimalCount]="2" [formControl]="getControl(i, 'maxCoilWeight')" [max]="9999999999">
								<mat-icon matSuffix class="pencil-icon pencil-icon-red" svgIcon="copo_pencil"></mat-icon>
								<mat-hint>
									<span>{{ getMaxCoilWeightHintText() }}</span>
								</mat-hint>
								<mat-error *ngIf="checkMinMaxCoilWeight(i)" [matTooltip]="('need4steel.wizard.maxcoilweight.range.error' | translate) +' '+ getMaxCoilWeightHintText()">
									<span translate>need4steel.wizard.maxcoilweight.range.error</span>&nbsp;<span>{{ getMaxCoilWeightHintText() }}</span>
								</mat-error>
							</mat-form-field>
						</ng-container>
						<ng-container *ngIf="getWeightType() === 'maxWeightPerWidthUnitValue'">
							<mat-form-field [hideRequiredMarker]="true" class="card-container-column step-product-spec-field" floatLabel="always" subscriptSizing="dynamic">
								<mat-label class="card-content-label-1 field-width" translate>need4steel.wizard.product.specific.weight
								</mat-label>
								<input matInput class="field-width" type="number" formControlName="maxSpecificWeight"
									(change)="onMaxSpecificWeightChange(i, $event)" [readonly]="isMaxSpecWeightDisabled(i)" copoInputNumber [decimalCount]="2" [formControl]="getControl(i, 'maxSpecificWeight')" [max]="9999999999">
								<mat-icon matSuffix class="pencil-icon pencil-icon-red" svgIcon="copo_pencil"></mat-icon>
								<mat-hint>
									<span>{{ getMaxSpecificWeightHintText(i) }}</span>
								</mat-hint>
								<mat-error *ngIf="checkMinMaxSpecificWeight(i)"
									[matTooltip]="('need4steel.wizard.maxspecificweight.range.error' | translate) +' '+ getMaxSpecificWeightHintText(i)">
									<span translate>need4steel.wizard.maxspecificweight.range.error</span>&nbsp;<span>{{ getMaxSpecificWeightHintText(i) }}</span>
								</mat-error>
							</mat-form-field>
						</ng-container>
						<mat-form-field [hideRequiredMarker]="true" class="card-container-column step-product-spec-field mobile-coil" floatLabel="always" subscriptSizing="dynamic">
							<mat-label class="placeholder card-content-label-1" translate>need4steel.wizard.stepper.product.coil</mat-label>
							<input matInput class="coil-input" type="number" formControlName="coil"
								(change)="onCoilNumberChange(i, $event)" [readonly]="isCoilDisabled(i)" copoInputNumber [decimalCount]="0" [formControl]="getControl(i, 'coil')" [max]="9999999999">
							<mat-icon matSuffix class="pencil-icon pencil-icon-red" svgIcon="copo_pencil"></mat-icon>
							<mat-error *ngIf="checkCoilError(i)" [matTooltip]="'need4steel.wizard.coil.error' | translate">
								<span translate>need4steel.wizard.coil.error</span>
							</mat-error>
						</mat-form-field>
					</div>
					<!-- 2nd row -->
					<div class="sub-content">
						<div class="card-content-left">
							<ng-container *ngIf="secondRowVariables" formGroupName="variableFormGroup">
							@for (variable of secondRowVariables; track variable.field) {
								@if (!isVariableSpecific(variable.field)) {
									<mat-form-field class="copo-content-product card-header-double-span copo-form-field" subscriptSizing="dynamic">
									<mat-label class="card-content-label">
										<ng-container *ngIf="variable.fieldDescription === toleranceField; else otherVariables">
										<span translate>need4steel.wizard.thickness.tolerance.field</span>
										</ng-container>
										<ng-template #otherVariables>
										{{getFieldLabel(variable.field)}}
										</ng-template>
									</mat-label>
									<mat-select [formControlName]="variable.field"
												[value]="getVariableListValue(i, variable.field)"
												[matTooltip]="getVariableListValue(i, variable.field)"
												(selectionChange)="prepareDataAndCallForSimulateA2Cproduct(i)">
										<ng-container *ngFor="let option of getVariableOptions(i, variable); let j=index">
										<mat-option *ngIf="variable.field === 'additionalTest' && j === 0" value="">
											<span translate>fastlane.itemlist.product.coil_axis.default</span>
										</mat-option>
										<mat-option [value]="option.description" [matTooltip]="option.description">
											<span>{{option.description}}&nbsp;</span>
										</mat-option>
										</ng-container>
									</mat-select>
									<mat-error *ngIf="variable.field === 'packagingCode' && isNotValidConstraints(i, variable.field)">
										<span translate>need4steel-logistic-routes.packaging.errormsg</span>
									</mat-error>
									</mat-form-field>
								}
							}
							</ng-container>
						</div>
						<div class="card-content-right price-info-block">
							<div class="copo-price-block">
								<span *ngIf="getLoader(i) === 'true'">
									<copo-loading-spinner class="loading-icon"></copo-loading-spinner>
								</span>
								<span *ngIf="getConfigErrorMsg(i) !== '' || getConfigErrorMsg(i).length > 0" class="copo-hint-warning"><mat-icon svgIcon="alert" class="copo-hint-warning-icon" matTooltip="Error occurred"></mat-icon></span>
								<span class="copo-underscore">{{getTotalPrice(i) }}</span>
								<b><span translate>need4steel-product-details.effectivedelivered</span></b>
							</div>
							<div *ngIf="getLoader(i) !== 'true' && getConfigErrorMsg(i) === '' && this.getPriceNumber(i) > 0 && hasExchangeRateToDisplay()" class="estimated-price-line">
								<i><span translate>need4steel.wizard.estimated</span> {{ getEstimatedPrice(i) }}/t <span translate>need4steel-summary-details.effectivedelivered</span></i>
							</div>
						</div>
					</div>
				</div>
				<mat-divider class="mat-divider"></mat-divider>
			</div>
		</div>
	</div>
</form>